import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-plus\"><path d=\"M12.5,0A12.5,12.5,0,1,0,25,12.5,12.52,12.52,0,0,0,12.5,0Zm0,22A9.5,9.5,0,1,1,22,12.5,9.51,9.51,0,0,1,12.5,22Z\" /><polygon class=\"plus-1\" id=\"icon-plus_plus-1\" points=\"18.12 11 18.12 14 6.88 13.99 6.88 11 18.12 11\" /><polygon class=\"plus-2\" id=\"icon-plus_plus-2\" points=\"11 6.88 14 6.88 13.99 18.12 11 18.12 11 6.88\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/plus.svg
// module id = 301
// module chunks = 0 1